<template>
  <div class="home-wrapper">
    <div class="home-box">
      <div class="header-img">
        <img src="https://oss.aqdpay.com/appweb/drugPrize/text.png" alt="">
      </div>
      <div class="content-wrapper">
        <div action=""  class="custom-form">
          <div class="form-item">
            <div class="form-control">
              <input name="phone" type="text" maxlength="11" class="form-input" placeholder="请填写手机号码" v-model="phone">
            </div>
          </div>
          <div class="form-item form-code-item">
            <div class="form-control">
              <input class="form-input" name="authcode" maxlength="8" type="text" placeholder="请填写验证码" v-model="authcode">
            </div>
            <button class="form-code-btn" :disabled="disabled" @click="sendCode">{{btntxt}}</button>
          </div>
          <div class="form-item-button">
            <van-button class="form-btn" :loading="loading" type="primary" loading-text="参加活动" @click.prevent="formCodeSubmit">参加活动</van-button>
          </div>
          <div class="agree-wrapper">
            <div class="auth-status" @click="handleDown">下载便捷青岛查看中奖结果</div>
            <div class="auth-agree">
              <span class="auth-iconfont" @click="handleSelect">
                <i class="iconfont" :class="[ isSelect ? 'icon-ok' : 'icon-kunselect']"></i>
              </span>
              <span>同意《<span class="agree-protocol" @click="handleProtocol">医保城联合运营活动协议</span>》</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rule-box">
      <rule-list></rule-list>
    </div>
    <van-popup class="custom-popup" v-model="showProtocol" round>
      <div class="protocol-box">
        <protocol-list></protocol-list>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast, Popup, Button } from 'vant'
import { getSendCode } from '@/api/khCoupon'
import { getRegister } from '@/api/drugPrize'
import ruleList from './component/prizeRule.vue'
import protocolList from './component/prizeProtocol.vue'

export default {
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
    ruleList,
    protocolList
  },
  data () {
    return {
      loading: false,
      showProtocol: false,
      status: null,
      statusText: null,
      disabled: false,
      time: 0,
      btntxt: '发送验证码',
      phone: '',
      authcode: '',
      isSelect: false
    }
  },
  methods: {
    formCodeSubmit (e) {
      e.preventDefault()
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      }
      if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      }
      if (!this.authcode) {
        Toast({
          message: '验证码不能为空'
        })
        return
      }
      if (!this.isSelect) {
        Toast({
          message: '请勾选同意医保城联合运营活动协议'
        })
        return
      }
      const requestData = {
        mobile: this.phone,
        verifyCode: this.authcode
      }
      this.loading = true
      getRegister(requestData).then((res) => {
        this.loading = false
        if (res.data.code !== 200) {
          Toast({
            message: res.data.message,
            duration: 2500
          })
          this.loading = false
        } else if (res.data.code === 200) {
          this.$router.push({ path: '/prizeResult' })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelect () {
      this.isSelect = !this.isSelect
    },
    handleProtocol () {
      this.showProtocol = true
    },
    handleCancel () {
      this.showProtocol = false
    },
    handleDown () {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
    },
    checkPhone (phone) {
      let reg = /^1[3456789]\d{9}$/
      if (reg.test(phone)) {
        return true
      } else {
        return false
      }
    },
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后再获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '获取验证码'
        this.disabled = false
      }
    },
    sendCode (e) {
      e.preventDefault()
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      } else if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      } else {
        this.time = 60
        this.disabled = true
        this.timer()
      }
      let data = {
        clientId: 'bjqd-hqActivity_h5',
        phone: this.phone,
        type: 3
      }
      getSendCode(data).then((res) => {
        if (res.data.code === 50003) {
          Toast({
            message: '只有新用户才可领取此优惠！',
            duration: 1500
          })
        } else if (res.data.code !== 200) {
          Toast({
            message: res.data.message,
            duration: 1500
          })
        }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
.home-wrapper {
  min-height: 100vh;
  background: #EBF3FF;
}
.home-box  {
  min-height: 100vh;
  position: relative;
  background: url('https://oss.aqdpay.com/appweb/drugPrize/bgHome.png') no-repeat left top;
  background-size: cover;
}
.header-img {
  padding-top: 10vh;
  margin-left: 6vw;
  width: 60%;
  margin-bottom: 8vh;
  img {
    width: 100%;
  }
}
.rule-box {
  padding: 18px 15px;
}
.custom-popup {
  box-sizing: border-box;
  width: 88%;
  padding: 15px;
  max-height: 500px;
}
.custom-form {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 0;
  border-radius: 5px;
  width: 90%;
}
.form-item {
  display: flex;
  align-items: center;
  height: 40px;
  margin:  10px 20px;
  padding: 0 15px;
  border-radius: 40px;
  overflow: hidden;
  background: #fff;
}
.form-item-button {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.form-item-blue {
  height: 30px;
  line-height: 30px;
  padding: 0 30px;
  margin-bottom: 10px;
  background-color: #FE4C31;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  /deep/ .van-divider {
    line-height: 30px;
  }
}
.form-control {
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  padding: 6px;
  border-radius: 5px;
  padding: 4px 8px;
}
.form-input {
  width: 100%;
  height: 100%;
  background: #fff;
  outline: none;
  font-size: 14px;
}
.form-btn {
  height: 40px;
  white-space: nowrap;
  font-size: 16px;
  padding: 0 35px;
  border-radius: 60px;
  border: 1px solid #fff;
  background: linear-gradient(180deg,#27acda, #3153bf);
  box-shadow: 0px 2px 4px 0px rgba(44,68,104,0.80);
}
.form-code-item {
  background: #fff;
}
.form-code-btn {
  margin-left: 8px;
  padding: 8px 10px;
  height: 100%;
  border-radius: 5px;
  white-space: nowrap;
  font-size: 14px;
  color: #6087C1;
  line-height: 1;
  outline: none;
  background: #fff;
}
.form-code-btn:disabled {
  color: #6087C1;
}
.agree-wrapper {
  margin: 20px 0;
  font-size: 13px;
}
.auth-agree {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-radius: 3px;
  .auth-iconfont {
    display: inline-flex;
    align-items: center;
    margin-right: 6px;
    background: #fff;
    color: #fff;
    border-radius: 4px;
    padding: 1px 2px;
  }
  .icon-kunselect {
    font-size: 14px;
    color: #fff;
  }
  .icon-ok {
    font-size: 14px;
    color: #6087C1;
  }
}
.auth-status {
  margin-bottom: 20px;
  text-align: center;
  color: #fff;
  text-decoration: underline;
}
</style>
